<template>
    <div class="row">
        <div class="col-xs-12">
            <div class="card-box">
                <h4 class="header-title m-t-0 m-b-20 text-dark">{{ $t('deals_by_source') }}</h4>
                <div v-pml-block="isLoading" style="min-height: 200px;">
                    <div ref="chart" v-show="hasChart"></div>
                    <pml-ec-line v-if="!hasChart"></pml-ec-line>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import c3 from 'c3'

    export default {
        name: 'RealTime',
        props: {
            'isLoading': {
                type: Boolean,
                required: true,
                default: false
            },
            'chartData': {
                type: Object | Boolean,
                required: true
            }
        },
        watch: {
            chartData () {
                this.buildChart()
            }
        },
        computed: {
            hasChart () {
                return this.chartData && this.chartData.data.length
            }
        },
        methods: {
            buildChart () {
                c3.generate({
                    bindto: this.$refs.chart,
                    data: {
                        columns: this.chartData.data,
                        type: 'spline'
                    },
                    color: {
                        pattern: this.chartData.colors
                    },
                    axis: {
                        x: {
                            type: 'category',
                            categories: this.chartData.period
                        }
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/sources/components/RealTime.vue